import React from 'react'
import { router } from 'src/router'
import { RouterProvider } from 'react-router-dom'
import { Loading as RouterLoaderLoading } from 'src/components/common/Loading'
import { ModalContextProvider } from 'src/provider/ModalContextProvider'
import { GlobalStyles } from 'src/styles/globalStyle'
import { ToastContextProvider } from 'src/provider/ToastContextProvider'
import 'react-loading-skeleton/dist/skeleton.css'
import { ChannelContextProvider } from 'src/provider/ChannelContextProvider'
import { SkeletonTheme } from 'react-loading-skeleton'

const App = () => {
  return (
    <ChannelContextProvider>
      <ToastContextProvider>
        <ModalContextProvider>
          <SkeletonTheme baseColor="var(--black-10)" duration={0.8}>
            <RouterProvider router={router} fallbackElement={<RouterLoaderLoading.Default />} />
          </SkeletonTheme>
          <GlobalStyles />
        </ModalContextProvider>
      </ToastContextProvider>
    </ChannelContextProvider>
  )
}

export default App
